import React, { useState } from "react";
import ManageCookies from "./ManageCookies";
import "../styles/Footer.css";

const Footer = () => {
  const [showManageCookies, setShowManageCookies] = useState(false);

  return (
    <>
      <footer className="footer">
        <div className="footer-container">

          <nav className="footer-nav">
            <a href="/privacy-policy">Política de Privacidade</a>
            <a href="/terms-of-service">Termos de Uso</a>
            <a href="/portal">Portal</a>
            <button
              className="cookie-link"
              onClick={() => setShowManageCookies(true)}
            >
              Gerenciar Cookies
            </button>
          </nav>

          <div className="footer-extra">
            <a href="/excluir-conta" className="delete-account-link">
              Excluir minha conta
            </a>
          </div>

          <p className="footer-meta">
            &copy; 2024 RondaGO · ACL Administração de Aplicativos LTDA · CNPJ: 57.276.139/0001-80. Todos os direitos reservados.
          </p>
        </div>
      </footer>

      {showManageCookies && (
        <ManageCookies onClose={() => setShowManageCookies(false)} />
      )}
    </>
  );
};

export default Footer;
